import { useTranslations } from 'next-intl';
import { usePathname, useSearchParams, useParams } from 'next/navigation';
import { Link } from '@/i18n/routing';

import { joinSearchQuery } from '@/utils';
import { listTabs } from '../api_utils';
import { TabsBox } from '../TabsBox';

export const Tabs = ({ tab }) => {
  const t = useTranslations();
  const query = useParams();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [, params = ''] = `${pathname}?${searchParams}`.split('?');

  const searchQuery = { ...query };
  searchParams.forEach((value, key) => (searchQuery[key] = value));

  return (
    <TabsBox>
      {listTabs.map((tabItem, index) => (
        <Link
          key={index}
          href={`/listings${index ? `/filters/${tabItem.slug}` : ''}${
            params
              ? `${joinSearchQuery({ ...searchQuery, tab: undefined })}`
              : ``
          }`}
          shallow={true}
          className={`${
            (tab && tab === tabItem.slug) || (!tab && !index)
              ? 'text-slate-500 after:bg-primary-800'
              : ''
          } sm:py-2 relative inline-flex gap-2 items-center text-slate-500 hover:text-slate-500 pl-1.5 pr-2.5 after:w-full after:absolute after:bottom-0 after:inset-x-0 after:h-[3px] hover:after:bg-slate-700 after:ease-linear after:delay-75 after:transition-colors`}
        >
          <i
            className={`icon-${tabItem.iconName} text-[24px] text-slate-500`}
            aria-hidden="true"
          />
          <span className="text-sm font-medium leading-normal whitespace-nowrap">
            {t(`listings.filters.bar.${tabItem.slug}`)}
          </span>
        </Link>
      ))}
    </TabsBox>
  );
};
